"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXStarknetProvider = void 0;
const core_1 = require("@okxconnect/core");
class OKXStarknetProvider {
    constructor(provider) {
        this.STARKNET_CHAIN_ID = "starknet:mainnet";
        this.provider = provider;
    }
    getChain(chainId) {
        if (chainId == null) {
            chainId = this.STARKNET_CHAIN_ID;
        }
        if (chainId != this.STARKNET_CHAIN_ID) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED, "The chainId:" + chainId + "is wrong for OKXStarknetProvider");
        }
        return chainId;
    }
    getAccount(chainId) {
        var _a, _b, _c, _d, _e;
        let account = (_b = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces[core_1.NameSpaceKeyStarknet]) === null || _b === void 0 ? void 0 : _b.accounts.filter(function (account) {
            return account.startsWith(chainId);
        })[0];
        if (!account) {
            // if (required) {
            //      throw new Error('Account not found')
            // }
            return undefined;
        }
        const accountArray = account.split(':');
        const address = account.split(':')[2];
        let extra = (_e = (_d = (_c = this.provider.session) === null || _c === void 0 ? void 0 : _c.namespaces[core_1.NameSpaceKeyStarknet]) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e[(`${accountArray[0]}:${accountArray[1]}`)];
        let publicKey = "";
        if (extra != undefined) {
            publicKey = extra["publicKey"];
        }
        if (!address) {
            // if (required) {
            //     throw new Error('Address not found')
            // }
            return undefined;
        }
        return {
            address: address,
            pubKey: publicKey
        };
    }
    /**
     *
     * @param chainId
     * @param signerAddress
     * @param data: { types, primaryType, domain, message } as TypedData
     * @returns [signedDataR, signedDataS]
     */
    signMessage(signerAddress, typedData, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            if (signerAddress.length == 0) {
                signerAddress = this.getAccount(chainId)["address"];
            }
            let signData = {
                "chainId": chainId,
                "method": "starknet_signMessage",
                "params": {
                    "accountAddress": signerAddress,
                    "typedData": typedData
                }
            };
            try {
                const ret = yield this.provider.request(signData, chainId);
                if ('result' in ret) {
                    let results = ret.result;
                    if (typeof results == 'string') {
                        results = JSON.parse(results);
                    }
                    return [results["signedDataR"], results["signedDataS"]];
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    /**
     * sendTransaction
     * @param chainId
     * @param signerAddress
     * @param transaction
     * @returns { transaction_hash }
     */
    sendTransaction(signerAddress, transaction, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            let transactionData = {
                "accountAddress": signerAddress,
                "executionRequest": transaction
            };
            let data = {
                "method": "starknet_sendTransaction",
                "params": {
                    "data": JSON.stringify(transactionData),
                    "from": signerAddress
                }
            };
            try {
                const ret = yield this.provider.request(data, chainId);
                if ('result' in ret) {
                    return { transaction_hash: ret.result };
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    /**
     *
     * signMessage old API（rarely used, no need provide to external）
     * @param chainId
     * @param payload
     * @returns {transaction_hash, class_hash}
     */
    signMessageDeclareContractPayload(payload, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            try {
                let data = {
                    "method": "starknet_signMessage",
                    "params": payload
                };
                const ret = yield this.provider.request(data, chainId);
                if ('result' in ret) {
                    return {
                        "transaction_hash": ret.result["txHash"],
                        "class_hash": ret.result["classHash"]
                    };
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                return error;
                // throw new OKXConnectError(OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    /**
     * sendTransaction old API（rarely used, no need provide to external）
     * @param chainId
     * @param signerAddress
     * @param calls
     * @param abis
     * @param transactionsDetail
     * @returns { transaction_hash }
     */
    /// todo： 
    /// 修改方法名
    /// chainId 放后面
    sendMessageExecuteTransactionDetail(signerAddress, calls, abis, transactionsDetail, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            chainId = this.getChain(chainId);
            const transactions = Array.isArray(calls) ? calls : [calls];
            const executionRequest = {
                "calls": transactions,
                "abis": abis,
                "transactionsDetail": {
                    "nonce": transactionsDetail === null || transactionsDetail === void 0 ? void 0 : transactionsDetail.nonce,
                    "maxFee": transactionsDetail === null || transactionsDetail === void 0 ? void 0 : transactionsDetail.nonce,
                    "version": transactionsDetail === null || transactionsDetail === void 0 ? void 0 : transactionsDetail.version,
                }
            };
            return this.sendTransaction(signerAddress, executionRequest, chainId);
        });
    }
}
exports.OKXStarknetProvider = OKXStarknetProvider;
